import React from 'react'
import { CancelButtonView } from 'components'

export default () => <CancelButtonView fontSize="2.5rem" />
